
export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '7643935f8fmsh355eb26d1dbd758p1af588jsna011db13e4d5',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_API_KEY = "c8a092e28a28ff55d34a5157d10aecbb";

